'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const AppleFilledIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.0833 7.09265C16.6015 7.09265 18.168 7.13878 19.402 8.40764C19.1752 8.59856 18.9127 8.84544 18.6619 9.14099C17.9912 9.9314 17.3319 11.1289 17.3319 12.7689C17.3319 14.6619 18.1718 15.9609 19.0177 16.7755C19.4148 17.1579 19.8165 17.4375 20.1413 17.6297C20.1009 17.7355 20.0539 17.8534 20.0001 17.981C19.7681 18.5311 19.4137 19.2522 18.9176 19.976C18.4366 20.6683 17.996 21.2815 17.5114 21.7283C17.0401 22.1629 16.5882 22.3826 16.0855 22.3826C15.516 22.3826 15.1726 22.2331 14.6871 22.0216C14.6759 22.0167 14.6646 22.0118 14.6532 22.0069C14.1173 21.7736 13.4721 21.5064 12.4476 21.5064C11.4454 21.5064 10.7575 21.7811 10.1966 22.0181C10.1801 22.0251 10.1638 22.032 10.1476 22.0388C9.619 22.2624 9.26653 22.4115 8.76747 22.4115C8.33391 22.4115 7.92179 22.2213 7.44977 21.7846C6.96453 21.3357 6.49022 20.6965 5.93024 19.911C4.7302 18.2034 3.75 15.5205 3.75 12.9996C3.75 9.0584 6.25998 7.15033 8.56339 7.15033C9.14103 7.15033 9.69666 7.33998 10.2949 7.5784C10.3567 7.60303 10.4204 7.62874 10.4851 7.6549C10.7146 7.74761 10.9584 7.8461 11.1862 7.92312C11.4808 8.02271 11.8209 8.11305 12.1725 8.11305C12.521 8.11305 12.8677 8.01451 13.1631 7.91263C13.3684 7.84186 13.5971 7.75127 13.8192 7.66331C13.9153 7.62523 14.0102 7.58764 14.1014 7.55237C14.7464 7.30295 15.3959 7.09265 16.0833 7.09265Z",
          fill: "currentColor",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.2941 4.54C14.5141 5.476 13.2421 6.208 12.0061 6.112C11.8381 4.84 12.4621 3.508 13.1821 2.68C13.9861 1.744 15.3301 1.048 16.4461 1C16.5901 2.296 16.0741 3.604 15.2941 4.54Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpAppleFilledIcon = forwardRef(AppleFilledIcon);

export { VpAppleFilledIcon as default };
